<template>
  <div v-if="event" :idfoevent="event.idfoevent.toString()" class="simple-event-component clearfix">
    <div v-if="isDebug" class="debug">
      idfoevent {{ event.idfoevent }} <br />
      eventdisplayorder {{ event.eventdisplayorder }}<br />
      eventrows {{ event.eventrows }}
    </div>
    <!-- PREMATCH -->
    <div class="flex-row" v-if="event.idfobolifestate === 'O'">
      <div class="event-info" >
        <div class="info-head" v-if="!event.isoutright">
          <h2 class="sport-name" v-if="showheader === undefined || showheader">
            <img v-if="(brand_translux4 && !isSportIconAvailableForTranslux4) || brand_translux3 || brand_translux2" class="logo" src="static/img/logo-event.png" alt="Logo">
            <icon v-if="brand_translux4 && isSportIconAvailableForTranslux4" :name="'icon-' + event.fosporttypename.replace(/ /g, '')" :colorName="'translux4'"></icon>
            <template v-if="headertype === 'DATE'">
              <template v-if="isDateToday">
                {{ $t('Today') }}
              </template>
              <template v-else-if="isDateTomorrow">
                {{ $t('Tomorrow') }}
              </template>
              <template v-else>
                {{ event.tsDate }}
              </template>
            </template>
            <template v-else>{{ event.fosporttypename || event.idfosporttype }}</template>
          </h2>
          <div class="names-date">
            <div class="listcode-date" :class="{'showparticipantlogo': teamLogoVisibility}">
              <span v-if="!(brand_translux4 || brand_translux3 || brand_translux2)" class="listcode">{{ listCode.away || '-' }}</span>
              <span class="time">
                <span v-if="event.idfobolifestate === 'O'">
                  <span v-if="brand_translux4 || brand_translux3 || brand_translux2">{{ event.tsExpectedStart | moment(dateFormats.dayAndMonthShort) }}</span>
                  <span class="day" v-if="isDateToday">{{ $t('Today') }}</span>
                  <span class="day" v-if="isDateTomorrow">{{ $t('Tomorrow') }}</span>
                  <span class="day" v-if="!isDateToday && !isDateTomorrow">
                    <span v-if="brand_translux1">{{ event.tsExpectedStart | moment(dateFormats.dayNameDayAndMonth) }}</span>
                    <span v-else>{{ event.tsExpectedStart | moment(dateFormats.dayName) }}</span>
                  </span>
                  <span class="hour">{{ event.tsExpectedStart | moment(dateFormats.shortTime) }} {{ event.tsExpectedStart | moment('A') }}</span>

                </span>
                <span v-else>{{ $t('Finished') }}</span>
              </span>
              <span v-if="!(brand_translux4 || brand_translux3 || brand_translux2)" class="listcode">{{ listCode.home || '-' }}</span>
            </div>
            <!-- Show AWAY - HOME participants when sport is not SOCCER -->
            <div class="names" :class="{'team-logos': teamLogoVisibility}" v-if="!isSportReverseParticipants">
              <span class="away">
                <span v-if="showparticipantlogo" class="team-logo" :style="awayTeamLogoStyle"></span>
                <span v-if="brand_translux4 || brand_translux3 || brand_translux2" class="listcode">{{ listCode.away || '-' }}</span>
                <span class="team-name-wrapper">
                  <span class="team-name">{{ event.participantnameaway}}</span>
                  <span class="pitcher" v-if="event.idfosporttype === 'BASEBALL'">
                    <span class="name">{{ event.awaypitchername }}</span>
                    <span class="stats" v-if="showParticipantStats && (awayParticipantPitcherRecord || awayParticipantPitcherEra)">
                      <span>{{awayParticipantPitcherRecord}}</span>
                      <span v-if="awayParticipantPitcherRecord && awayParticipantPitcherEra">,&nbsp;</span>
                      <span>{{awayParticipantPitcherEra}}</span>
                    </span>
                  </span>
                </span>
                <span v-if="showParticipantStats && awayParticipantWins && awayParticipantLosses" class="stats">
                  {{awayParticipantWins}} - {{awayParticipantLosses}}
                  <span v-if="awayParticipantTies">&nbsp;- {{ awayParticipantTies }}</span>
                  <span v-if="awayParticipantOvertimeLosses">&nbsp;- {{ awayParticipantOvertimeLosses }}</span>
                </span>
              </span>
              <span class="home">
                <span v-if="showparticipantlogo" class="team-logo" :style="homeTeamLogoStyle"></span>
                <span v-if="brand_translux4 || brand_translux3 || brand_translux2" class="listcode">{{ listCode.home || '-' }}</span>
                <span class="team-name-wrapper">
                  <span class="team-name">{{ event.participantnamehome }}</span>
                  <span class="pitcher" v-if="event.idfosporttype === 'BASEBALL'">
                    <span class="name">{{ event.homepitchername }}</span>
                    <span class="stats" v-if="showParticipantStats && (homeParticipantPitcherRecord || homeParticipantPitcherEra)">
                      <span>{{homeParticipantPitcherRecord}}</span>
                      <span v-if="homeParticipantPitcherRecord && homeParticipantPitcherEra">,&nbsp;</span>
                     <span>{{homeParticipantPitcherEra}}</span>
                    </span>
                  </span>
                </span>
                <span v-if="showParticipantStats && homeParticipantWins && homeParticipantLosses" class="stats">
                  {{homeParticipantWins}} - {{homeParticipantLosses}}
                  <span v-if="homeParticipantTies">&nbsp;- {{ homeParticipantTies }}</span>
                  <span v-if="homeParticipantOvertimeLosses">&nbsp;- {{ homeParticipantOvertimeLosses }}</span>
                </span>
              </span>
            </div>
            <!-- Show HOME - AWAY participants when sport is SOCCER -->
            <div class="names" :class="{'team-logos': teamLogoVisibility}" v-if="isSportReverseParticipants">
              <span class="home">
                <span v-if="showparticipantlogo" class="team-logo" :style="homeTeamLogoStyle"></span>
                <span v-if="brand_translux4 || brand_translux3 || brand_translux2" class="listcode">{{ listCode.home || '-' }}</span>
                <span class="team-name-wrapper">
                  <span class="team-name">{{ event.participantnamehome }}</span>
                  <span class="pitcher" v-if="event.idfosporttype === 'BASEBALL'">
                    <span class="name">{{ event.homepitchername }}</span>
                    <span class="stats" v-if="showParticipantStats && (homeParticipantPitcherRecord || homeParticipantPitcherEra)">
                      <span>{{homeParticipantPitcherRecord}}</span>
                      <span v-if="homeParticipantPitcherRecord && homeParticipantPitcherEra">,&nbsp;</span>
                     <span>{{homeParticipantPitcherEra}}</span>
                    </span>
                  </span>
                </span>
                <span v-if="showParticipantStats && homeParticipantWins && homeParticipantLosses" class="stats">
                  {{homeParticipantWins}} - {{homeParticipantLosses}}
                  <span v-if="homeParticipantTies">&nbsp;- {{ homeParticipantTies }}</span>
                  <span v-if="homeParticipantOvertimeLosses">&nbsp;- {{ homeParticipantOvertimeLosses }}</span>
                </span>
              </span>
              <span class="away">
                <span v-if="showparticipantlogo" class="team-logo" :style="awayTeamLogoStyle"></span>
                <span v-if="brand_translux4 || brand_translux3 || brand_translux2" class="listcode">{{ listCode.away || '-' }}</span>
                <span class="team-name-wrapper">
                  <span class="team-name">{{ event.participantnameaway}}</span>
                  <span class="pitcher" v-if="event.idfosporttype === 'BASEBALL'">
                    <span class="name">{{ event.awaypitchername }}</span>
                    <span class="stats" v-if="showParticipantStats && (awayParticipantPitcherRecord || awayParticipantPitcherEra)">
                      <span>{{awayParticipantPitcherRecord}}</span>
                      <span v-if="awayParticipantPitcherRecord && awayParticipantPitcherEra">,&nbsp;</span>
                      <span>{{awayParticipantPitcherEra}}</span>
                    </span>
                  </span>
                </span>
                <span v-if="showParticipantStats && awayParticipantWins && awayParticipantLosses" class="stats">
                  {{awayParticipantWins}} - {{awayParticipantLosses}}
                  <span v-if="awayParticipantTies">&nbsp;- {{ awayParticipantTies }}</span>
                  <span v-if="awayParticipantOvertimeLosses">&nbsp;- {{ awayParticipantOvertimeLosses }}</span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- OUTRIGHT -->
        <div class="info-head" v-if="event.isoutright">
          <h2 class="sport-name">
            <img v-if="(brand_translux4 && !isSportIconAvailableForTranslux4) || brand_translux3 || brand_translux2" class="logo" src="static/img/logo-event.png" alt="Logo">
            <icon v-if="brand_translux4 && isSportIconAvailableForTranslux4" :name="'icon-' + event.fosporttypename.replace(/ /g, '')" :colorName="'translux4'"></icon>
            {{ event.fosporttypename || event.idfosporttype }}
          </h2>
          <span class="team-name">{{ event.eventname }}</span>
          <span class="time">
            <span v-if="event.idfobolifestate === 'O'">
              <span class="day" v-if="isDateToday">{{ $t('Today') }}</span>
              <span class="day" v-if="isDateTomorrow">{{ $t('Tomorrow') }}</span>
              <span class="day" v-if="!isDateToday && !isDateTomorrow">{{ event.tsExpectedStart | moment(dateFormats.longDate) }}</span>
              <span class="hour">{{ event.tsExpectedStart | moment(dateFormats.shortTime) }} {{ event.tsExpectedStart | moment('A') }}</span>

            </span>
            <span v-else>{{ $t('Finished') }}</span>
          </span>
        </div>
      </div>
      <markets v-if="event.idfobolifestate === 'O' && (popularMarkets.length > 0 || screenConfiguration.is2showeventsin2columns || screenConfiguration.is2showsingleevent)"
             class="markets-container"
             :event="event"
             :markets="popularMarkets"
             :is2displayhorizontally="event.is2displayhorizontally"
             :showheader="showheader"></markets>
    </div>

    <div class="expanded-markets" :class="{'open': event.idfobolifestate === 'O' && expandedMarkets.length > 0}">
      <markets v-if="event.idfobolifestate === 'O' && expandedMarkets.length > 0"
             class="markets-container"
             :event="event"
             :markets="expandedMarkets"
             :is2displayhorizontally="event.is2displayhorizontally">
      </markets>
    </div>

    <!-- RESULTED -->
    <div class="event-info" v-if="event.idfobolifestate !== 'O'">

      <div class="info-head">
        <h2 class="sport-name" v-if="showheader === undefined || showheader">
          <img v-if="(brand_translux4 && !isSportIconAvailableForTranslux4) || brand_translux3 || brand_translux2" class="logo" src="static/img/logo-event.png" alt="Logo">
          <icon v-if="brand_translux4 && isSportIconAvailableForTranslux4" :name="'icon-' + event.fosporttypename.replace(/ /g, '')" :colorName="'translux4'"></icon>
          <template v-if="headertype === 'DATE'">{{ event.tsDate }}</template>
          <template v-else>{{ event.fosporttypename || event.idfosporttype }}</template>
        </h2>
        <div class="names-date">
          <div class="listcode-date" :class="{'showparticipantlogo': teamLogoVisibility}">
            <span class="listcode">{{ listCode.away || '-' }}</span>
            <span class="time">{{ $t('Finished') }}</span>
            <span class="listcode">{{ listCode.home || '-' }}</span>
          </div>
          <div class="names" :class="{'team-logos': teamLogoVisibility}">
            <span class="away">
              <span v-if="showparticipantlogo" class="team-logo" :style="awayTeamLogoStyle"></span>
              <div class="team-name-wrapper">
                <span class="team-name">{{ event.participantnameaway}}</span>
                <span class="pitcher" v-if="event.idfosporttype === 'BASEBALL'">{{ event.awaypitchername }}</span>
              </div>
            </span>
            <span class="home">
              <span v-if="showparticipantlogo" class="team-logo" :style="homeTeamLogoStyle"></span>
              <div class="team-name-wrapper">
                <span class="team-name">{{ event.participantnamehome }}</span>
                <span class="pitcher" v-if="event.idfosporttype === 'BASEBALL'">{{ event.homepitchername }}</span>
              </div>
            </span>
          </div>
        </div>
      </div>

      <div class="info" v-if="!hideScores">
        <table>
          <thead>
            <tr v-if="showheader === undefined || showheader">
              <th class="final-result">
                {{ $t('Results.FSC') }}
              </th>

              <th v-if="event.idfosporttype === 'SOCCER'" class="halftime">
                {{ $t('Results.HT') }}
              </th>

              <template v-if="event.idfosporttype === 'BASKETBALL' || event.idfosporttype === 'NFL'">
                <th class="period" v-if="result.periodnumber < 5" v-for="result in periodResults">
                  {{result.periodnumber}}
                </th>
                <th class="period" v-if="result.periodnumber > 4" v-for="result in periodResults">
                  {{ $t('Results.OT') }}
                </th>
              </template>

              <template v-if="event.idfosporttype === 'ICE HOCKEY'">
                <th class="period" v-if="result.periodnumber < 4" v-for="result in periodResults">
                  {{result.periodnumber}}
                </th>
                <th class="period" v-if="result.periodnumber === 4" v-for="result in periodResults">
                  {{ $t('Results.OT') }}
                </th>
                <th class="period" v-if="result.periodnumber === 5" v-for="result in periodResults">
                  {{ $t('Results.SO') }}
                </th>
              </template>

              <template v-if="event.idfosporttype === 'BASEBALL'">
                <th class="period"  v-if="result.periodnumber < 10" v-for="result in periodResults">
                  {{ result.periodnumber }}
                </th>
                <th class="period"  v-if="result.periodnumber > 9" v-for="result in periodResults">
                  {{ $t('Results.OT') }}
                </th>
              </template>

              <template v-if="event.idfosporttype === 'TENNIS'">
                <th class="period" v-for="result in periodResults">
                  {{ result.periodnumber }}
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <!-- AWAY TEAM -->
            <tr class="away">
              <td class="match score">
                {{ finalResult && finalResult.awayscoreline }}
              </td>
              <td v-if="event.idfosporttype === 'SOCCER'" class="score halftimescore">
                {{ soccerHTResult && soccerHTResult.awayscoreline }}
              </td>
              <td v-if="event.idfosporttype !== 'SOCCER'" v-for="result in periodResults" class="score">
                {{ result.awayscoreline }}
              </td>
            </tr>

            <!-- HOME TEAM -->
            <tr class="home">
              <td class="match score">
                {{ finalResult && finalResult.homescoreline }}
              </td>
              <td v-if="event.idfosporttype === 'SOCCER'" class="score">
                {{ soccerHTResult && soccerHTResult.homescoreline }}
              </td>
              <td v-if="event.idfosporttype !== 'SOCCER'" v-for="result in periodResults" class="score">
                {{ result.homescoreline }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Single coupon footer -->
  </div>
</template>
<script>
  import markets from '@/components/bettingoffer/markets'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import Brands from '@/components/mixins/Brands'
  import UrlParameters from '@/components/mixins/UrlParameters'
  import TeamLogo from '@/components/mixins/TeamLogo'
  import ParticipantInfos from '@/components/mixins/ParticipantInfos'

  import Icon from '@/components/common/Icon'

  export default {
    name: 'couponEvent',

    props: [
      'event',
      'showheader',
      'headertype'
    ],

    components: {
      markets,
      Icon
    },

    mixins: [
      BettingOffer,
      UrlParameters,
      TeamLogo,
      ParticipantInfos,
      Brands
    ],

    computed: {
      hideScores () {
        return (window.ctsautoconf && window.ctsautoconf.HIDE_SCORES) || false
      },
      // prepatch and resulted
      teamLogos () {
        return {
          logoHome: this.event && this.event.logohome,
          logoAway: this.event && this.event.logoaway
        }
      },
      periodResults () {
        return this.event && this.event.results && this.event.results.filter(res => res.periodnumber > 0)
      },
      finalResult () {
        return this.event && this.event.results && this.event.results.find(res => res.periodnumber === -1)
      },
      soccerHTResult () {
        return this.event && this.event.results && this.event.results.find(res => res.periodnumber === 1)
      },
      listCode () {
        var listCodes = (this.event.listcode && this.event.listcode.split('|')) || [this.event.listcode || '', '']
        return {
          away: listCodes[0] || '',
          home: listCodes[1] || ''
        }
      },
      popularMarkets () {
        return (this.event.markets && this.event.markets.filter(mk => mk.isPopular)) || []
      },
      expandedMarkets () {
        return (this.event.markets && this.event.markets.filter(mk => mk.isExpanded)) || []
      },
      isDateTomorrow () {
        return this.isTomorrow
      },
      isDateToday () {
        return this.isToday
      },
      isSportIconAvailableForTranslux4 () {
        // to be removed as soon as possible !!!
        return ['ICE HOCKEY', 'HOCKEY', 'PRO HOCKEY', 'BASEBALL', 'BASKETBALL', 'FOOTBALL', 'NFL'].indexOf(this.event.idfosporttype) > -1
      },
      isSportReverseParticipants () {
        return ['SOCCER'].includes(this.event.idfosporttype) && this.brand_white1
      }
    },

    methods: {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .prematch
    .simple-event-component
      table
        width 30%
        float left
</style>



// WEBPACK FOOTER //
// src/components/bettingoffer/simpleEvent.vue